import React from 'react';
import clsx from 'clsx';
import Grid, { GridProps } from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';

import useStyles from './Sidebar.style';
import type { SidebarStylesProps } from './Sidebar.style';

type SidebarProps = GridProps & SidebarStylesProps;

const Sidebar: React.FC<SidebarProps> = ({
  children: sidebarChildren,
  className,
  firstChildTopSpacing,
  ...props
}) => {
  const stylesProps: SidebarStylesProps = { firstChildTopSpacing };
  const { sidebarBackground, sidebarContainer, sidebarTextSection } =
    useStyles(stylesProps);

  const children = React.Children.map(
    sidebarChildren,
    (child) => React.isValidElement(child) && child
  );

  // TODO: shouldn't need to check if children exists here, check should be before mapping in <Container />
  // Fixed in Material UI v5 (not recommended for production) https://github.com/mui-org/material-ui/issues/21711
  return children ? (
    <Grid
      container
      component="aside"
      direction="column"
      className={clsx(sidebarBackground, className)} // order of classNames doesn't matter here, passed-in styles from parent take precedence - https://material-ui.com/styles/advanced/#makestyles-withstyles-styled
      /* eslint-disable react/jsx-props-no-spreading */
      {...props}
    >
      <Container className={sidebarContainer}>
        {children.map((child, index) => (
          <Grid
            item
            className={sidebarTextSection}
            component="section"
            /* eslint-disable react/no-array-index-key */
            key={`sidebarText${index}`} // ok b/c list never changes
          >
            {child}
          </Grid>
        ))}
      </Container>
    </Grid>
  ) : null;
};

export default Sidebar;
